import { useState, useCallback } from 'react';
import { useNotification } from '../../../../contexts/NotificationContext';

export const useSurgicalSafetyValidation = (formData) => {
  const { showNotification } = useNotification();
  const [errors, setErrors] = useState({});

  const validateField = useCallback((name, value) => {
    let error = "";
    switch (name) {
      case 'ward_room_no':
        if (!value || !value.trim()) error = "Ward/Room No. is required";
        break;
      case 'procedure_name':
        if (!value || !value.trim()) error = "Procedure name is required";
        break;
      case 'primary_consultant':
        if (!value) error = "Primary Consultant is required";
        break;
      case 'date_time_of_surgery':
        if (!value) error = "Date & Time is required";
        break;
      default:
        break;
    }
    setErrors((prev) => ({ ...prev, [name]: error }));
    return error === "";
  }, []);

  const validateForm = useCallback(() => {
    const requiredFields = [
      { key: 'ward_room_no', label: 'Ward / Room No.' },
      { key: 'procedure_name', label: 'Procedure Name' },
      { key: 'primary_consultant', label: 'Primary Consultant' },
      { key: 'date_time_of_surgery', label: 'Date & Time of Surgery' },
    ];

    const tempErrors = {};
    requiredFields.forEach(({ key, label }) => {
      if (!formData[key] || String(formData[key]).trim() === '') {
        tempErrors[key] = `${label} is required`;
      }
    });

    setErrors(tempErrors);

    if (Object.keys(tempErrors).length > 0) {
      const firstKey = Object.keys(tempErrors)[0];
      const el = document.querySelector(`[name="${firstKey}"]`);
      if (el) { 
        el.scrollIntoView({ behavior: 'smooth', block: 'center' }); 
        el.focus(); 
      }
      showNotification('error', requiredFields.filter(f => tempErrors[f.key]).map(f => f.label));
    }

    return Object.keys(tempErrors).length === 0;
  }, [formData, showNotification]);

  return { errors, setErrors, validateField, validateForm };
};
